<template>
    <div class="pricing-cards">
        <div class="pricing-card pricing-card1">
            <div class="pricing-card-content">
                <span class="pricing__logo">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="37.167px" height="42.083px" viewBox="0 0 37.167 42.083" enable-background="new 0 0 37.167 42.083" xml:space="preserve">
                        <g>
                            <polygon fill="none" stroke="#FFFFFF" stroke-width="2.5" stroke-linecap="round" points="35.117,30.494 35.117,11.498 18.667,2 
                                2.216,11.498 2.216,30.494 18.667,39.992 	"/>
                            <g>
                                <polyline fill="none" stroke="#FFFFFF" stroke-width="2.5" stroke-linecap="round" points="2.216,11.498 18.667,20.996 
                                    18.667,39.992 		"/>
                            </g>
                        </g>
                    </svg>
                </span>
                <div class="pricing__title">
                    BASIC
                    <div class="pricing__title__underline"></div>
                </div>
                <div class="pricing__plan">25</div>
                <div class="pricing__cycle">one-time</div>
                <hr class="pricing__hr" />
                <div class="pricing__lists">
                    <ul class="pricing__list">
                        <li>
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16.241px" height="13.437px" viewBox="0 0 16.241 13.437" enable-background="new 0 0 16.241 13.437" xml:space="preserve">
                                <g>
                                    <path d="M13.985,0l-1.064,1.128L5.51,8.99L3.287,6.767L2.191,5.671L0,7.862l1.096,1.096l3.351,3.351l1.128,1.128 l1.096-1.16l8.507-9.022l1.064-1.128L13.985,0z"/>
                                </g>
                            </svg>
                            Logo files in PNG format</li>
                    </ul>
                </div>
                <PricingButton class="pricing__button1" />
            </div>
        </div>
        <div class="pricing-card pricing-card2">
            <div class="pricing-card-content">
                <span class="pricing__logo">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="55.625px" height="54.375px" viewBox="0 0 55.625 54.375" enable-background="new 0 0 55.625 54.375" xml:space="preserve">
                        <g>
                            <polygon fill="none" stroke="#FFFFFF" stroke-width="2.5" stroke-linecap="round" points="36.595,42.359 36.595,22.078 
                                19.03,11.937 1.466,22.078 1.466,42.359 19.03,52.5 	"/>
                            <polyline fill="none" stroke="#FFFFFF" stroke-width="2.5" stroke-linecap="round" points="1.466,22.078 19.03,32.218 19.03,52.5 	
                                "/>
                            <polygon fill="none" stroke="#FFFFFF" stroke-width="2.5" stroke-linecap="round" points="54.159,32.264 54.159,11.983 
                                36.595,1.842 19.03,11.983 19.03,32.264 36.595,42.405 	"/>
                            <polyline fill="none" stroke="#FFFFFF" stroke-width="2.5" stroke-linecap="round" points="19.03,11.983 36.595,22.123 
                                36.595,42.405 	"/>
                            <line fill="none" stroke="#FFFFFF" stroke-width="2.5" stroke-linecap="round" x1="54.159" y1="11.983" x2="36.595" y2="22.123"/>
                        </g>
                    </svg>
                </span>
                <div class="pricing__title">
                    DESIGNER
                    <div class="pricing__title__underline"></div>
                </div>
                <div class="pricing__plan">65</div>
                <div class="pricing__cycle">one-time</div>
                <hr class="pricing__hr" />
                <div class="pricing__lists">
                    <ul class="pricing__list">
                        <li>
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16.241px" height="13.437px" viewBox="0 0 16.241 13.437" enable-background="new 0 0 16.241 13.437" xml:space="preserve">
                                <g>
                                    <path d="M13.985,0l-1.064,1.128L5.51,8.99L3.287,6.767L2.191,5.671L0,7.862l1.096,1.096l3.351,3.351l1.128,1.128 l1.096-1.16l8.507-9.022l1.064-1.128L13.985,0z"/>
                                </g>
                            </svg>
                            Logo design files
                        </li>
                        <li>
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16.241px" height="13.437px" viewBox="0 0 16.241 13.437" enable-background="new 0 0 16.241 13.437" xml:space="preserve">
                                <g>
                                    <path d="M13.985,0l-1.064,1.128L5.51,8.99L3.287,6.767L2.191,5.671L0,7.862l1.096,1.096l3.351,3.351l1.128,1.128 l1.096-1.16l8.507-9.022l1.064-1.128L13.985,0z"/>
                                </g>
                            </svg>
                            Brand style guide
                        </li>
                        <li>
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16.241px" height="13.437px" viewBox="0 0 16.241 13.437" enable-background="new 0 0 16.241 13.437" xml:space="preserve">
                                <g>
                                    <path d="M13.985,0l-1.064,1.128L5.51,8.99L3.287,6.767L2.191,5.671L0,7.862l1.096,1.096l3.351,3.351l1.128,1.128 l1.096-1.16l8.507-9.022l1.064-1.128L13.985,0z"/>
                                </g>
                            </svg>
                            Business card designs
                        </li>
                        <li>
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16.241px" height="13.437px" viewBox="0 0 16.241 13.437" enable-background="new 0 0 16.241 13.437" xml:space="preserve">
                                <g>
                                    <path d="M13.985,0l-1.064,1.128L5.51,8.99L3.287,6.767L2.191,5.671L0,7.862l1.096,1.096l3.351,3.351l1.128,1.128 l1.096-1.16l8.507-9.022l1.064-1.128L13.985,0z"/>
                                </g>
                            </svg>
                            Social media graphics
                        </li>
                    </ul>
                    <ul class="pricing__list">
                        <li>
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16.241px" height="13.437px" viewBox="0 0 16.241 13.437" enable-background="new 0 0 16.241 13.437" xml:space="preserve">
                                <g>
                                    <path d="M13.985,0l-1.064,1.128L5.51,8.99L3.287,6.767L2.191,5.671L0,7.862l1.096,1.096l3.351,3.351l1.128,1.128 l1.096-1.16l8.507-9.022l1.064-1.128L13.985,0z"/>
                                </g>
                            </svg>
                            Profile & app icons
                        </li>
                        <li>
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16.241px" height="13.437px" viewBox="0 0 16.241 13.437" enable-background="new 0 0 16.241 13.437" xml:space="preserve">
                                <g>
                                    <path d="M13.985,0l-1.064,1.128L5.51,8.99L3.287,6.767L2.191,5.671L0,7.862l1.096,1.096l3.351,3.351l1.128,1.128 l1.096-1.16l8.507-9.022l1.064-1.128L13.985,0z"/>
                                </g>
                            </svg>
                            Font pairing
                        </li>
                        <li>
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16.241px" height="13.437px" viewBox="0 0 16.241 13.437" enable-background="new 0 0 16.241 13.437" xml:space="preserve">
                                <g>
                                    <path d="M13.985,0l-1.064,1.128L5.51,8.99L3.287,6.767L2.191,5.671L0,7.862l1.096,1.096l3.351,3.351l1.128,1.128 l1.096-1.16l8.507-9.022l1.064-1.128L13.985,0z"/>
                                </g>
                            </svg>
                            Letterhead designs
                        </li>
                        <li>
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16.241px" height="13.437px" viewBox="0 0 16.241 13.437" enable-background="new 0 0 16.241 13.437" xml:space="preserve">
                                <g>
                                    <path d="M13.985,0l-1.064,1.128L5.51,8.99L3.287,6.767L2.191,5.671L0,7.862l1.096,1.096l3.351,3.351l1.128,1.128 l1.096-1.16l8.507-9.022l1.064-1.128L13.985,0z"/>
                                </g>
                            </svg>
                            Logo mockups
                        </li>
                    </ul>
                </div>
                <a class="pricing__see-sample" href="#">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="13.866px" height="13.867px" viewBox="0 0 13.866 13.867" enable-background="new 0 0 13.866 13.867" xml:space="preserve">
                        <g>
                            <path fill="#9AADD8" d="M1.583,13.867C0.71,13.867,0,13.156,0,12.283V3.366c0-0.873,0.71-1.583,1.583-1.583h3.483L6.45,3.166H2.028
                                c-0.355,0-0.646,0.29-0.646,0.646v8.025c0,0.355,0.29,0.646,0.646,0.646h8.025c0.356,0,0.646-0.29,0.646-0.646V7.416L12.083,8.8
                                v3.483c0,0.873-0.71,1.584-1.583,1.584H1.583z M6.265,8.517c-0.245,0-0.476-0.094-0.648-0.266C5.261,7.895,5.261,7.313,5.617,6.957 l4.349-4.349L8.161,0.802c-0.09-0.1-0.137-0.215-0.137-0.333C8.024,0.21,8.234,0,8.493,0h4.682c0.382,0,0.691,0.31,0.691,0.691 v4.682c0,0.259-0.21,0.469-0.469,0.469c-0.151,0-0.26-0.072-0.325-0.134L11.262,3.9L6.911,8.251 C6.739,8.423,6.509,8.517,6.265,8.517z"/>
                        </g>
                    </svg>
                    See sample assets
                </a>
                <PricingButton class="pricing__button2" />
            </div>
        </div>
        <div class="pricing-card pricing-card3">
            <div class="pricing-card-content">
                <span class="pricing__logo">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="42.75px" height="52px" viewBox="0 0 42.75 52" enable-background="new 0 0 42.75 52" xml:space="preserve">
                        <g transform="translate(0,-952.36218)">
                            <path fill="#FFFFFF" stroke="#FFFFFF" stroke-width="0.3" stroke-miterlimit="10" d="M28.371,955.781
                                c-0.131,0.003-0.262,0.03-0.384,0.077c-0.122,0.048-0.236,0.117-0.335,0.203c-0.099,0.086-0.182,0.19-0.246,0.304
                                c-0.064,0.115-0.107,0.24-0.128,0.37c-0.021,0.129-0.019,0.262,0.005,0.391c0.024,0.129,0.071,0.253,0.138,0.366
                                c0.133,0.226,0.347,0.403,0.594,0.492c6.318,2.381,10.82,8.481,10.82,15.649c0,4.856-2.067,9.213-5.366,12.273
                                c-0.136,0.126-0.24,0.286-0.301,0.46c-0.061,0.175-0.078,0.365-0.049,0.548l1.443,9.235l-17.708,4.622l-0.85-6.508
                                c-0.02-0.156-0.074-0.308-0.156-0.443c-0.082-0.135-0.192-0.252-0.321-0.342c-0.129-0.09-0.278-0.153-0.432-0.183
                                c-0.155-0.03-0.316-0.027-0.469,0.007L9.33,994.51l-0.907-5.542c-0.022-0.132-0.066-0.259-0.132-0.375
                                c-0.066-0.116-0.152-0.22-0.253-0.307c-0.102-0.086-0.219-0.155-0.344-0.201c-0.125-0.046-0.258-0.07-0.392-0.07H3.535
                                l2.131-10.123c0.019-0.089,0.027-0.181,0.024-0.272l-0.196-5.817c0.667-6.142,4.663-11.283,10.143-13.591
                                c0.139-0.056,0.267-0.14,0.374-0.246c0.107-0.106,0.192-0.233,0.25-0.371c0.058-0.139,0.087-0.289,0.087-0.439
                                c-0.001-0.15-0.031-0.3-0.089-0.438c-0.058-0.138-0.144-0.265-0.251-0.37c-0.107-0.105-0.235-0.189-0.375-0.244
                                c-0.139-0.056-0.29-0.083-0.44-0.081c-0.15,0.003-0.3,0.035-0.437,0.096c-6.253,2.634-10.798,8.511-11.529,15.522
                                c-0.005,0.052-0.007,0.104-0.006,0.156l0.194,5.763l-2.391,11.358c-0.035,0.165-0.032,0.337,0.007,0.501
                                c0.04,0.164,0.116,0.318,0.222,0.449c0.106,0.131,0.242,0.237,0.393,0.31c0.152,0.072,0.32,0.11,0.488,0.11h4.202l0.946,5.782
                                c0.025,0.152,0.081,0.3,0.165,0.43c0.083,0.13,0.194,0.243,0.322,0.329c0.128,0.086,0.274,0.146,0.426,0.174
                                c0.152,0.028,0.31,0.025,0.46-0.009l5.256-1.199l0.855,6.547c0.021,0.159,0.076,0.314,0.16,0.45
                                c0.084,0.137,0.198,0.255,0.331,0.345c0.133,0.09,0.286,0.151,0.444,0.178c0.158,0.027,0.322,0.02,0.478-0.02l19.948-5.207
                                c0.135-0.035,0.263-0.095,0.376-0.177c0.113-0.081,0.211-0.183,0.287-0.3c0.076-0.116,0.131-0.247,0.16-0.383
                                c0.029-0.136,0.034-0.277,0.012-0.415l-1.51-9.664c3.485-3.445,5.652-8.233,5.652-13.515c0-8.119-5.106-15.067-12.291-17.774
                                C28.674,955.803,28.522,955.777,28.371,955.781L28.371,955.781z"/>
                            <path fill="#FFFFFF" stroke="#FFFFFF" stroke-width="0.3" stroke-miterlimit="10" d="M18.866,953.362
                                c-0.149,0-0.306,0.032-0.444,0.089c-0.137,0.057-0.25,0.143-0.355,0.248c-0.105,0.105-0.191,0.218-0.248,0.355
                                c-0.057,0.137-0.089,0.295-0.089,0.444v14.31c-2.326,1.303-3.904,3.792-3.904,6.637c0,2.401,1.111,4.548,2.857,5.944l-2.644,4.596
                                c-0.077,0.129-0.121,0.26-0.142,0.408c-0.021,0.148-0.02,0.316,0.018,0.461c0.038,0.145,0.104,0.271,0.195,0.39
                                c0.091,0.119,0.207,0.227,0.337,0.302c0.13,0.075,0.277,0.123,0.426,0.142c0.149,0.019,0.299,0.006,0.444-0.035
                                c0.145-0.04,0.29-0.103,0.408-0.195c0.118-0.092,0.211-0.207,0.284-0.337l2.644-4.578c0.861,0.339,1.79,0.515,2.768,0.515
                                c4.19,0,7.613-3.422,7.613-7.612c0-2.845-1.577-5.333-3.904-6.637v-14.31c0-0.149-0.032-0.306-0.089-0.444
                                c-0.057-0.137-0.143-0.25-0.248-0.355c-0.105-0.105-0.218-0.191-0.355-0.248c-0.137-0.057-0.295-0.089-0.444-0.089L18.866,953.362
                                L18.866,953.362z M21.422,970.121c2.964,0,5.341,2.366,5.341,5.323c0,2.964-2.377,5.341-5.341,5.341
                                c-2.958,0-5.323-2.378-5.323-5.341C16.098,972.487,18.464,970.121,21.422,970.121z"/>
                        </g>
                        </svg>
                </span>
                <div class="pricing__title">
                    FULL SERVICE
                    <div class="pricing__title__underline"></div>
                </div>
                <div class="pricing__plan">175</div>
                <div class="pricing__cycle">one-time</div>
                <hr class="pricing__hr" />
                <div class="pricing__lists">
                    <ul class="pricing__list">
                        <li>
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16.241px" height="13.437px" viewBox="0 0 16.241 13.437" enable-background="new 0 0 16.241 13.437" xml:space="preserve">
                                <g>
                                    <path d="M13.985,0l-1.064,1.128L5.51,8.99L3.287,6.767L2.191,5.671L0,7.862l1.096,1.096l3.351,3.351l1.128,1.128 l1.096-1.16l8.507-9.022l1.064-1.128L13.985,0z"/>
                                </g>
                            </svg>
                            Everything in the designer package
                        </li>
                        <li>
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16.241px" height="13.437px" viewBox="0 0 16.241 13.437" enable-background="new 0 0 16.241 13.437" xml:space="preserve">
                                <g>
                                    <path d="M13.985,0l-1.064,1.128L5.51,8.99L3.287,6.767L2.191,5.671L0,7.862l1.096,1.096l3.351,3.351l1.128,1.128 l1.096-1.16l8.507-9.022l1.064-1.128L13.985,0z"/>
                                </g>
                            </svg>
                            Up to 10 fully original concepts created by our design team
                        </li>
                    </ul>
                </div>
                <PricingButton class="pricing__button3" />
            </div>
        </div>
    </div>
</template>

<script>
    import PricingButton from './PricingButton.vue';

    export default {
        name: 'PricingCardsDesktop',
        components: {
            PricingButton
        },
    }
</script>